import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import {
  listAdressesHeader,
  listAdressesTitle,
  adressesContainer,
  adressesDescription,
  separator,
} from "./carnet-adresse.module.scss"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { ListAdressHeader, Separator } from "./carnet-adresse-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import { coverSpeed } from "../../../constants"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import RenderAdresses from "./RenderAdresses/render-adresses"

//-----------------------Parent component---------------------------//

const CarnetAdresse = () => {
  const buildColors = useBuildData().theme_settings.palette
  const data = useStaticQuery(graphql`
    query {
      allNodeCarnetDAdresse(
        sort: { fields: field_ordre_carnet_d_adresse, order: DESC }
        filter: { field_mise_en_avant: { eq: true } }
        limit: 6
      ) {
        ...AllCarnetAdresse
      }
      taxonomyTermZoneDefinie(name: { eq: "carnet_d_adresse" }) {
        ...AllCarnetTaxo
      }
    }
  `)
  if (data.allNodeCarnetDAdresse.edges.length === 0) {
    return null
  }
  return (
    <>
      <ListAdressHeader className={listAdressesHeader}>
        <h2 className={listAdressesTitle}>
          {data.taxonomyTermZoneDefinie?.field_label || "Carnet d'adresses"}
        </h2>
        <AniLink
          cover
          direction="down"
          bg={buildColors.a_color_gradients.a_dark}
          duration={coverSpeed}
          className="btn"
          to="/adresses"
        >
          Tout voir
        </AniLink>
      </ListAdressHeader>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={adressesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={adressesContainer}>
        <RenderAdresses colors={buildColors} adressesData={data} />
      </div>
      <Separator className={separator}></Separator>
    </>
  )
}
//-----------------------Parent component---------------------------//

export default CarnetAdresse
